export default __webpack_public_path__ + "static/media/verify_icon4.80514cc3.png";